export const API_URL_OLD = 'https://searchnsettle.trigma.in/web/v1/'
export const API_URL = 'https://development.trigma.in:3002/api/'

//'https://development.trigma.in:3002/api/'

//'http://localhost:3002/api/'